import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import Login from './Login';
import reportWebVitals from './reportWebVitals';

const isAuthenticated = () => {
  const user = sessionStorage.getItem('user_token')
  debugger
  if (user && atob(user) === 'abQfnejDI3nnF9OM0Czs|mmcdharan') {
    return true
  }

  sessionStorage.removeItem('user_token')
  return false
}


ReactDOM.hydrate(
  <React.StrictMode>
    {
      isAuthenticated() ? <App /> : <Login />
    }
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();